const solicitudFondosRoutes = [
    {
        path: "/solicitud-fondos/:dato",
        name: "solicitud",
        component: () => import(/* webpackChunkName: "perfil" */ "../SolicitudFondos.vue")
    },
    
];
export default solicitudFondosRoutes;